import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { IconButton, Tooltip } from '@mui/material';
import { useId } from 'react';
import type { Tag } from 'models/tag';
import type { FC } from 'react';

interface ProductTagsProps {
  tags: Tag[];
}

const ProductTags: FC<ProductTagsProps> = ({ tags }) => {
  const componentId = useId();

  if (tags.length === 0) return null;

  return (
    <Tooltip
      title={
        <div role='tooltip'>
          {tags.map((tag) => (
            <div key={`${componentId}-tag-${tag.id}`}>{tag.name}</div>
          ))}
        </div>
      }>
      <IconButton
        size='small'
        aria-label={`Теги товара: ${tags.map((t) => t.name).join(', ')}`}
        sx={{ p: 0.5 }}>
        <LocalOfferIcon fontSize='inherit' color='action' />
      </IconButton>
    </Tooltip>
  );
};

export default ProductTags;
